module.exports = __webpack_public_path__ + "static/media/casino2.6410d18b.jpeg";